import script from "./ChatNumberedList.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatNumberedList.vue?vue&type=script&setup=true&lang=js"

import "./ChatNumberedList.vue?vue&type=style&index=0&id=26c1afa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26c1afa2"]])

export default __exports__